<div class="node-card" [ngClass]="'node-' + node.type"
     [class.highlighted]="highlightedUid === node.uid"
     [class.dimmed]="node.dimmed"
     [class.drop-allowed]="drag.dragged && drag.canDropOn(node)"
     [class.drop-hover]="dropHover === node"
     [class.wide-employees]="node.employeesExpanded && exportEmployeeColumns > 1"
     [attr.draggable]="editable"
     (dragstart)="onDragStart($event, node)" (dragend)="onDragEnd()"
     (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

  <div class="node-header">
    <mat-icon class="material-icons-outlined type-icon" aria-hidden="true">{{ typeIcon }}</mat-icon>
    <div class="node-titles">
      <div class="node-name" [matTooltip]="node.name" matTooltipShowDelay="600">{{ node.name }}</div>
      <div class="node-subtitle" *ngIf="node.subtitle">{{ node.subtitle }}</div>
    </div>
    <button mat-icon-button class="menu-button" [matMenuTriggerFor]="nodeMenu" aria-label="Actions">
      <mat-icon class="material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
    </button>
  </div>

  <div class="node-meta">
    <span *ngIf="node.type === 'position'" class="status-chip" [class.vacant]="node.isVacant">
      {{ node.isVacant ? 'Vacant' : 'Occupied' }}
    </span>
    <span class="count" [matTooltip]="node.slots ? 'Employees / slots' : 'Employees'">
      <mat-icon class="material-icons-outlined" aria-hidden="true">people</mat-icon><span class="export-label">Employees: </span>{{ occupancyLabel }}
    </span>
    <span class="count" *ngIf="childCount" [matTooltip]="node.type === 'position' ? 'Reporting positions' : 'Sub-organizations'">
      <mat-icon class="material-icons-outlined" aria-hidden="true">account_tree</mat-icon><span class="export-label">Reports: </span>{{ childCount }}
    </span>
  </div>

  <ng-container *ngIf="node.employees.length">
    <button *ngIf="!node.employeesExpanded" type="button" class="avatar-strip" (click)="toggleEmployees()"
            matTooltip="Show employees">
      <ng-container *ngFor="let employee of stripEmployees">
        <ng-container *ngTemplateOutlet="avatar; context: { $implicit: employee }"></ng-container>
      </ng-container>
      <span class="avatar more" *ngIf="hiddenEmployeeCount">+{{ hiddenEmployeeCount }}</span>
    </button>

    <div *ngIf="node.employeesExpanded" class="employee-list" [style.--export-columns]="exportEmployeeColumns" [style.--export-rows]="exportEmployeeRows">
      <div *ngFor="let employee of node.employees" class="employee-row"
           [attr.data-uid]="employee.uid"
           [class.highlighted]="highlightedUid === employee.uid"
           [attr.draggable]="editable"
           (dragstart)="onDragStart($event, employee)" (dragend)="onDragEnd()">
        <ng-container *ngTemplateOutlet="avatar; context: { $implicit: employee }"></ng-container>
        <div class="employee-text">
          <div class="employee-name" [matTooltip]="employee.name" matTooltipShowDelay="600">{{ employee.name }}</div>
          <div class="employee-subtitle" *ngIf="employee.subtitle">{{ employee.subtitle }}</div>
        </div>
        <button mat-icon-button class="menu-button" [matMenuTriggerFor]="employeeMenu"
                [matMenuTriggerData]="{ employee: employee }" aria-label="Employee actions">
          <mat-icon class="material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
        </button>
      </div>
      <button type="button" class="collapse-employees" (click)="toggleEmployees()">
        <mat-icon class="material-icons-outlined" aria-hidden="true">expand_less</mat-icon>Hide employees
      </button>
    </div>
  </ng-container>

  <div *ngIf="continuedOn" class="continued-on">See {{ continuedOn }}</div>

  <button *ngIf="node.children.length" type="button" class="expand-toggle" [class.expanded]="node.expanded"
          [matTooltip]="node.expanded ? 'Collapse' : 'Expand'" (click)="toggle.emit(node)">
    <ng-container *ngIf="node.expanded; else collapsedCount">
      <mat-icon class="material-icons-outlined" aria-hidden="true">expand_less</mat-icon>
    </ng-container>
    <ng-template #collapsedCount>{{ node.children.length }}</ng-template>
  </button>
</div>

<ng-template #avatar let-employee>
  <img *ngIf="hasPhoto(employee); else initialsAvatar" class="avatar" [src]="employee.photo" alt="" draggable="false"
       (error)="photoFailed(employee)" [matTooltip]="employee.name">
  <ng-template #initialsAvatar>
    <span class="avatar initials" [matTooltip]="employee.name">{{ initials(employee) }}</span>
  </ng-template>
</ng-template>

<mat-menu #nodeMenu="matMenu">
  <button mat-menu-item (click)="emit('details')">
    <mat-icon class="material-icons-outlined" aria-hidden="true">info</mat-icon>Details
  </button>
  <button mat-menu-item *ngIf="node.children.length" (click)="emit('focus')">
    <mat-icon class="material-icons-outlined" aria-hidden="true">center_focus_strong</mat-icon>Show only this branch
  </button>
  <ng-container *ngIf="editable">
    <ng-container *ngIf="node.type === 'position'">
      <button mat-menu-item (click)="emit('addPosition')">
        <mat-icon class="material-icons-outlined" aria-hidden="true">add</mat-icon>Add new position
      </button>
      <button mat-menu-item (click)="emit('addEmployee')">
        <mat-icon class="material-icons-outlined" aria-hidden="true">person_add</mat-icon>Add a new employee
      </button>
      <button mat-menu-item (click)="emit('edit')">
        <mat-icon class="material-icons-outlined" aria-hidden="true">edit</mat-icon>Edit position
      </button>
    </ng-container>
    <ng-container *ngIf="node.type === 'organization'">
      <button mat-menu-item (click)="emit('addOrganization')">
        <mat-icon class="material-icons-outlined" aria-hidden="true">add_business</mat-icon>Add a new organization
      </button>
      <button mat-menu-item (click)="emit('edit')">
        <mat-icon class="material-icons-outlined" aria-hidden="true">edit</mat-icon>Edit organization
      </button>
    </ng-container>
    <button mat-menu-item (click)="emit('delete')">
      <mat-icon class="material-icons-outlined" aria-hidden="true">delete_outline</mat-icon>Delete
    </button>
  </ng-container>
</mat-menu>

<mat-menu #employeeMenu="matMenu">
  <ng-template matMenuContent let-employee="employee">
    <button mat-menu-item (click)="emit('details', employee)">
      <mat-icon class="material-icons-outlined" aria-hidden="true">info</mat-icon>Details
    </button>
    <ng-container *ngIf="editable">
      <button mat-menu-item (click)="emit('edit', employee)">
        <mat-icon class="material-icons-outlined" aria-hidden="true">edit</mat-icon>Edit employee
      </button>
      <button mat-menu-item (click)="emit('delete', employee)">
        <mat-icon class="material-icons-outlined" aria-hidden="true">delete_outline</mat-icon>Delete
      </button>
    </ng-container>
  </ng-template>
</mat-menu>
